import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@/components/common/ui/Button';
import Favorite from '@material-ui/icons/Favorite';
import styles from 'styles/jss/original/components/shoppings/detailTitle';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import CurrencyFormat from 'react-currency-format';
import classNames from 'classnames';
import {
  GTM_CLICK_EVENT_CATEGORY,
  GTM_CLICK_EVENT_TITLE,
  GTM_CLICK_EVENT_PRICE
} from '@/constants/app';
import { IShopping } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  shopping: IShopping;
  onRequestUpdateFavorite: (id: string) => void;
  isFavorite: boolean;
  invalid: boolean;
};

const DetailTitle: React.FC<ComponentProps> = ({
  shopping,
  onRequestUpdateFavorite,
  isFavorite,
  invalid
}) => {
  const { id, title, slug, cat, price } = shopping.fields;
  const classes = useStyles();
  const handleClick = useCallback(
    (id: string) => {
      onRequestUpdateFavorite(id);
    },
    [onRequestUpdateFavorite]
  );
  return (
    <div className={classes.section}>
      <ul className={classes.snsIcon}>
        <li className={classes.flexItem}>
          <TwitterShareButton
            url={`https://smalldish.jp/shoppings/${slug}`}
            title={`${title} | smalldish`}
          >
            <Button color='white' round justIcon>
              <i className='fab fa-twitter' />
            </Button>
          </TwitterShareButton>
        </li>
        <li className={classes.flexItem}>
          <FacebookShareButton url={`https://smalldish.jp/shoppings/${slug}`}>
            <Button color='white' round justIcon>
              <i className='fab fa-facebook-f' />
            </Button>
          </FacebookShareButton>
        </li>
      </ul>
      <h5 className={GTM_CLICK_EVENT_CATEGORY}>{cat}</h5>
      <h1 className={classNames(classes.title, GTM_CLICK_EVENT_TITLE)}>{title}</h1>
      <h4 className={GTM_CLICK_EVENT_PRICE}>
        <CurrencyFormat value={price} displayType={'text'} thousandSeparator={true} prefix={'¥'} />
      </h4>
      <div className={classes.action}>
        <Button
          color='warning'
          round
          onClick={() => handleClick(id)}
          disabled={invalid}
          className={classes.flexItem}
        >
          <Favorite color={isFavorite ? 'secondary' : 'inherit'} />
          お気に入り
        </Button>
      </div>
    </div>
  );
};

export default DetailTitle;
